"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Control = (0, styled_1.default)('div', {
    shouldForwardProp: (prop) => (0, is_prop_valid_1.default)(prop) && !['disabled'].includes(prop)
})({
    alignItems: 'center',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    outlineStyle: 'solid',
    outlineWidth: 1,
    padding: '9px 18px'
}, ({ theme, isOpen, disabled, hasError }) => ({
    backgroundColor: theme.palette.colors.lotion,
    outlineColor: theme.palette.colors.lightPeriwinkle,
    ...(isOpen && {
        outlineColor: theme.palette.colors.dodgerBlue,
        outlineWidth: 2
    }),
    ...(disabled && {
        backgroundColor: theme.palette.colors.azureish,
        cursor: 'default'
    }),
    ...(hasError && {
        color: theme.palette.colors.crayola,
        outlineColor: theme.palette.colors.crayola
    })
}));
exports.default = Control;
//# sourceMappingURL=Control.js.map